import type { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next'
import Head from 'next/head'
import { Content } from '../components/Content'
import { Nav } from '../components/Nav'
import { Seo } from '../components/Seo'
import { MapType, ModelTypes, One, OrderDirection, Thunder } from '../generated/content'
import { createZeusConnection } from '../lib/next/loaders/graphql-zeus/connection'
import { ContentQuery } from '../queries/ContentQuery'
import styles from './Home.module.sass'

export default function Home(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
	const pageContent = props.page?.content
	const pageBlocks = pageContent?.blocks
	const footer = props.footer?.localesByLocale
	const menu = props.menu
	//console.log(pageContent)
	console.log(pageBlocks)
	return (
		<div className={styles.container}>
			<Head>
				<title>Rokytnice</title>
				<meta name="description" content="Generated by create next app" />
				<link rel="preconnect" href="https://fonts.gstatic.com"></link>
				<link rel="icon" type="image/png" href="/favicon.png" />
				<link
					href="https://fonts.googleapis.com/css2?family=Lexend:wght@300;400;500;600;700&family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400&display=swap"
					rel="stylesheet"></link>
				<link
					href="https://fonts.googleapis.com/css2?family=Lexend:wght@300;400;500;600;700&family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400&family=Rokkitt:wght@100;300;400;500;600;700&display=swap"
					rel="stylesheet"></link>
			</Head>
			<Seo seo={props.seo} />
			{/* <Dump data={pageContent} /> */}
			<main>
				<Nav locale={props.locale} menu={menu} />
				{pageContent && <Content blocks={pageBlocks ?? []} />}
				<footer className="footer" id="kontakt">
					<div className="container">
						<h2>{footer?.headline}</h2>
						<div className="footer-inner">
							<article>
								<p>{footer?.text}</p>
								{footer?.email && (
									<a href={`mailto:${footer?.email}`}>{footer?.email}</a>
								)}
								<br></br>
								{footer?.tel && <a href={`tel:${footer?.tel}`}>{footer?.tel}</a>}
							</article>
							<article>
								<p>{footer?.textSecond}</p>
							</article>
							<div className="socials">
								<h4>sledujte nás</h4>
								<div className="socials-inner">
									{footer?.instagram && (
										<a href={footer?.instagram}>
											<svg
												height="511pt"
												viewBox="0 0 511 511.9"
												width="511pt"
												fill="currentColor"
												xmlns="http://www.w3.org/2000/svg">
												<path d="m510.949219 150.5c-1.199219-27.199219-5.597657-45.898438-11.898438-62.101562-6.5-17.199219-16.5-32.597657-29.601562-45.398438-12.800781-13-28.300781-23.101562-45.300781-29.5-16.296876-6.300781-34.898438-10.699219-62.097657-11.898438-27.402343-1.300781-36.101562-1.601562-105.601562-1.601562s-78.199219.300781-105.5 1.5c-27.199219 1.199219-45.898438 5.601562-62.097657 11.898438-17.203124 6.5-32.601562 16.5-45.402343 29.601562-13 12.800781-23.097657 28.300781-29.5 45.300781-6.300781 16.300781-10.699219 34.898438-11.898438 62.097657-1.300781 27.402343-1.601562 36.101562-1.601562 105.601562s.300781 78.199219 1.5 105.5c1.199219 27.199219 5.601562 45.898438 11.902343 62.101562 6.5 17.199219 16.597657 32.597657 29.597657 45.398438 12.800781 13 28.300781 23.101562 45.300781 29.5 16.300781 6.300781 34.898438 10.699219 62.101562 11.898438 27.296876 1.203124 36 1.5 105.5 1.5s78.199219-.296876 105.5-1.5c27.199219-1.199219 45.898438-5.597657 62.097657-11.898438 34.402343-13.300781 61.601562-40.5 74.902343-74.898438 6.296876-16.300781 10.699219-34.902343 11.898438-62.101562 1.199219-27.300781 1.5-36 1.5-105.5s-.101562-78.199219-1.300781-105.5zm-46.097657 209c-1.101562 25-5.300781 38.5-8.800781 47.5-8.601562 22.300781-26.300781 40-48.601562 48.601562-9 3.5-22.597657 7.699219-47.5 8.796876-27 1.203124-35.097657 1.5-103.398438 1.5s-76.5-.296876-103.402343-1.5c-25-1.097657-38.5-5.296876-47.5-8.796876-11.097657-4.101562-21.199219-10.601562-29.398438-19.101562-8.5-8.300781-15-18.300781-19.101562-29.398438-3.5-9-7.699219-22.601562-8.796876-47.5-1.203124-27-1.5-35.101562-1.5-103.402343s.296876-76.5 1.5-103.398438c1.097657-25 5.296876-38.5 8.796876-47.5 4.101562-11.101562 10.601562-21.199219 19.203124-29.402343 8.296876-8.5 18.296876-15 29.398438-19.097657 9-3.5 22.601562-7.699219 47.5-8.800781 27-1.199219 35.101562-1.5 103.398438-1.5 68.402343 0 76.5.300781 103.402343 1.5 25 1.101562 38.5 5.300781 47.5 8.800781 11.097657 4.097657 21.199219 10.597657 29.398438 19.097657 8.5 8.300781 15 18.300781 19.101562 29.402343 3.5 9 7.699219 22.597657 8.800781 47.5 1.199219 27 1.5 35.097657 1.5 103.398438s-.300781 76.300781-1.5 103.300781zm0 0" />
												<path d="m256.449219 124.5c-72.597657 0-131.5 58.898438-131.5 131.5s58.902343 131.5 131.5 131.5c72.601562 0 131.5-58.898438 131.5-131.5s-58.898438-131.5-131.5-131.5zm0 216.800781c-47.097657 0-85.300781-38.199219-85.300781-85.300781s38.203124-85.300781 85.300781-85.300781c47.101562 0 85.300781 38.199219 85.300781 85.300781s-38.199219 85.300781-85.300781 85.300781zm0 0" />
												<path d="m423.851562 119.300781c0 16.953125-13.746093 30.699219-30.703124 30.699219-16.953126 0-30.699219-13.746094-30.699219-30.699219 0-16.957031 13.746093-30.699219 30.699219-30.699219 16.957031 0 30.703124 13.742188 30.703124 30.699219zm0 0" />
											</svg>
										</a>
									)}
									{footer?.facebook && (
										<a href={footer?.facebook}>
											<svg
												version="1.1"
												id="Capa_1"
												x="0px"
												y="0px"
												width="96.124px"
												height="96.123px"
												viewBox="0 0 96.124 96.123"
												fill="currentColor">
												<g>
													<path
														d="M72.089,0.02L59.624,0C45.62,0,36.57,9.285,36.57,23.656v10.907H24.037c-1.083,0-1.96,0.878-1.96,1.961v15.803
		c0,1.083,0.878,1.96,1.96,1.96h12.533v39.876c0,1.083,0.877,1.96,1.96,1.96h16.352c1.083,0,1.96-0.878,1.96-1.96V54.287h14.654
		c1.083,0,1.96-0.877,1.96-1.96l0.006-15.803c0-0.52-0.207-1.018-0.574-1.386c-0.367-0.368-0.867-0.575-1.387-0.575H56.842v-9.246
		c0-4.444,1.059-6.7,6.848-6.7l8.397-0.003c1.082,0,1.959-0.878,1.959-1.96V1.98C74.046,0.899,73.17,0.022,72.089,0.02z"
													/>
												</g>
											</svg>
										</a>
									)}
									{footer?.youtube && (
										<a href={footer?.youtube}>
											<svg
												height="682pt"
												fill="currentColor"
												viewBox="-21 -117 682.66672 682"
												width="682pt"
												xmlns="http://www.w3.org/2000/svg">
												<path d="m626.8125 64.035156c-7.375-27.417968-28.992188-49.03125-56.40625-56.414062-50.082031-13.703125-250.414062-13.703125-250.414062-13.703125s-200.324219 0-250.40625 13.183593c-26.886719 7.375-49.03125 29.519532-56.40625 56.933594-13.179688 50.078125-13.179688 153.933594-13.179688 153.933594s0 104.378906 13.179688 153.933594c7.382812 27.414062 28.992187 49.027344 56.410156 56.410156 50.605468 13.707031 250.410156 13.707031 250.410156 13.707031s200.324219 0 250.40625-13.183593c27.417969-7.378907 49.03125-28.992188 56.414062-56.40625 13.175782-50.082032 13.175782-153.933594 13.175782-153.933594s.527344-104.382813-13.183594-154.460938zm-370.601562 249.878906v-191.890624l166.585937 95.945312zm0 0" />
											</svg>
										</a>
									)}
								</div>
							</div>
						</div>
					</div>
				</footer>
			</main>
		</div>
	)
}

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
	const contember = createZeusConnection(Thunder, 'content')
	const locale = context.locale as string
	const localeUrl = locale === context.defaultLocale ? '/' : `/${locale}`
	const url = `${localeUrl}${
		context.query.page ? '/' + ((context.query.page as string[]) ?? []).join('/') : ''
	}`
	console.log(locale)
	console.log('url vole')
	console.log(url)

	const query = await contember.query({
		getMenu: [
			{ by: { unique: One.One } },
			{
				items: [
					{ orderBy: [{ order: OrderDirection.asc }] },
					{
						localesByLocale: [
							{ by: { locale: { code: locale } } },
							{
								link: [
									{},
									{
										externalLink: true,
										internalLink: [{}, { url: true }],
										title: true,
										type: true,
									},
								],
							},
						],
					},
				],
			},
		],
		getLinkable: [
			{ by: { url } },
			{
				page: [
					{},
					{
						title: true,
						content: [{}, ContentQuery()],
						seo: [
							{},
							{
								ogImage: [
									{},
									{
										height: true,
										width: true,
										url: true,
										type: true,
									},
								],
								title: true,
								ogTitle: true,
								description: true,
								ogDescription: true,
							},
						],
					},
				],
			},
		],
		getFooter: [
			{ by: { unique: One.One } },
			{
				localesByLocale: [
					{ by: { locale: { code: locale } } },
					{
						email: true,
						facebook: true,
						headline: true,
						instagram: true,
						tel: true,
						youtube: true,
						text: true,
						textSecond: true,
					},
				],
			},
		],
	})

	const page = query.getLinkable?.page ?? null
	const footer = query.getFooter ?? null
	const menu = query.getMenu ?? null

	return {
		props: {
			page,
			footer,
			locale,
			seo: page?.seo ? page?.seo : null,
			menu,
		},
	}
}

export type ContentResult = MapType<ModelTypes['EditorContent'], ReturnType<typeof ContentQuery>>
export type SeoType = Exclude<
	InferGetServerSidePropsType<typeof getServerSideProps>['seo'],
	undefined
>
export type NavType = Exclude<
	InferGetServerSidePropsType<typeof getServerSideProps>['menu'],
	undefined
>
